import React from 'react';
import { useLocation } from 'react-router-dom';
import ToolBar from '../../components/common/Header/ToolBar';
import { useViewport } from '../../helpers/hooks/commonHooks';

// Redux stuff
import { useSelector } from 'react-redux';
import { selectAuthInfo } from '../../../features/auth/authSlice';
import { getUserProfile } from '../../../features/user/userSlice';
import {
  getIsInternalUser,
  getConfigurationLoadingStatus
} from '../../../features/video-configuration/videoConfigurationSlice';
import { DESKTOP_SD_VIEWPORT_SIZE, STATUS_SUCCESS } from '../../constants/configuration';

const HeaderToolBarContainer = () => {
  const { viewportWidth } = useViewport();
  const { isAuthorized, statusIsAuthorized } = useSelector(selectAuthInfo);
  const user = useSelector(getUserProfile);
  const configurationLoadingStatus = useSelector(getConfigurationLoadingStatus);
  const isInternalUser = useSelector(getIsInternalUser);
  const location = useLocation();

  const isLoading = configurationLoadingStatus === STATUS_SUCCESS;
  return (
    <ToolBar
      isDesktop={viewportWidth >= DESKTOP_SD_VIEWPORT_SIZE}
      isAuthorized={isAuthorized}
      statusIsAuthorized={statusIsAuthorized}
      location={location}
      user={user}
      isUserInternal={isInternalUser}
      isLoading={isLoading}
    />
  );
};

export default HeaderToolBarContainer;
